const ConnectingLine = ({ lineCoords }) => {
  return (
    <svg
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}
    >
      <polyline
        points={`${lineCoords.startX},${lineCoords.startY} ${lineCoords.midX},${lineCoords.startY} ${lineCoords.midX},${lineCoords.endY} ${lineCoords.endX},${lineCoords.endY}`}
        stroke="#40404380"
        fill="none"
        strokeWidth="2"
        strokeDasharray={'5'}
      />
    </svg>
  )
}
export default ConnectingLine
